import React, { ReactNode } from "react";
import clsx from "clsx";

import {
  EVariantExamsHistory,
  getVariantsClassNames
} from "components/VetExams/ExamHistoryItem/helper";
import useStyles from "./styles";

export interface IHorseInfoTableData {
  [key: string]: string | ReactNode;
}

interface IProps {
  data: IHorseInfoTableData;
  rowHeight?: number | "auto";
  children?: ReactNode;
  variant?: EVariantExamsHistory;
}

const HorseInfoTable = (props: IProps) => {
  const { data, rowHeight, children, variant } = props;
  const classes = useStyles({ rowHeight });
  const { detailsClassName } = getVariantsClassNames(variant);

  const renderTableRows = () => {
    return Object.keys(data).map(rowName => {
      return (
        <div key={rowName} className={clsx(classes.row, detailsClassName)}>
          <div className={classes.rowName}>{rowName}</div>
          <div className={classes.rowValue}>{data[rowName]}</div>
        </div>
      );
    });
  };

  return (
    <div className={clsx(classes.table, detailsClassName)}>
      {renderTableRows()}
      {children}
    </div>
  );
};

export default HorseInfoTable;
